/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { TIMED_ENTRY_PREFIX } from '../constants';

export const SET_FETCH_TOUR_TIMES_STATUS = `${TIMED_ENTRY_PREFIX}SET_FETCH_TOUR_TIMES_STATUS`;
export const FETCH_TOUR_TIMES_SUCCESS = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_TIMES_SUCCESS`;
export const FETCH_TOUR_TIMES_ERROR = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_TIMES_ERROR`;
export const FETCH_TOUR_TIMES = `${TIMED_ENTRY_PREFIX}FETCH_TOUR_TIMES`;
export const CLEAR_TOUR_TIMES = `${TIMED_ENTRY_PREFIX}CLEAR_TOUR_TIMES`;
export const SET_TOUR_TIME_FILTER = 'SET_TOUR_TIME_FILTER';

export function setTourTimeFilter(tourTimeFilters) {
    return {
        type: SET_TOUR_TIME_FILTER,
        payload: tourTimeFilters,
    };
}

export function fetchTourTimes({ facilityId, date, tourId, reservationId }) {
    return {
        type: FETCH_TOUR_TIMES,
        payload: { facilityId, date, tourId, reservationId },
    };
}

export function fetchTourTimesSuccess(data) {
    return (dispatch, getState) => {
        const tourTimeFilter = getState().timedEntry.filters.tourTimeFilter;

        dispatch({
            type: FETCH_TOUR_TIMES_SUCCESS,
            payload: data,
        });
        dispatch(setTourTimeFilter(tourTimeFilter));
    };
}

export function fetchTourTimesError(error) {
    return {
        type: FETCH_TOUR_TIMES_ERROR,
        payload: error,
    };
}

export function setFetchTourTimesStatus(status) {
    return {
        type: SET_FETCH_TOUR_TIMES_STATUS,
        payload: status,
    };
}

export function clearTourTimes() {
    return (dispatch) => {
        dispatch({
            type: CLEAR_TOUR_TIMES,
        });

        dispatch(
            setTourTimeFilter({
                earlyMorning: false,
                morning: false,
                earlyAfternoon: false,
                afternoon: false,
                evening: false,
                lateNight: false,
            })
        );
    };
}
